export const config = {
  server: {
    port: process.env.PORT ?? 3000,
  },
};
